<template>
  <YoutubeVideo
    :aria-label
    :is-mobile
    @click="emit('click')"
    @start="emit('start')"
  />
</template>

<script setup lang="ts">
import YoutubeVideo from '~/scopes/product-core/components/presentationals/GalleryNew/components/YoutubeVideo/YoutubeVideo.vue'

defineProps<{
  isMobile: boolean
  ariaLabel?: string
}>()

const emit = defineEmits<{
  (e: 'click'): void
  (e: 'start'): void
}>()
</script>
